export default __webpack_public_path__ + "static/al_hussaini-2de6cba1b05941b201d17f6bf74c1554.webp";